import styled from 'styled-components'

type SizeProps = {
  isSmall?: boolean,
  active?:boolean,
  disabled?:boolean,
}

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isSmall' && prop !== 'disabled',
})<SizeProps>`
  display: flex;
  width: auto;
  min-width: max-content;
  max-width: 100%;
  height: ${({isSmall}) => isSmall ? '32px' : '40px'};
  background-color: ${({theme}) => theme.grey[300]};
  border-radius: ${({theme}) => theme.radius.control};
  margin-top: 6px;
  box-sizing: border-box;
  opacity: ${({disabled}) => disabled ? '0.6' : ''};
  pointer-events: ${({disabled}) => disabled ? 'none' : 'auto'};
  /* width:200px; */
  /* align-items: center; */

  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(140px, 100%), 1fr));
    width: 100%;
    min-width: 0;
    height: auto;
    min-height: ${({isSmall}) => isSmall ? '32px' : '40px'};
    overflow: visible;
  }

`

export const Button = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'isSmall' && prop !== 'active',
})<SizeProps>`
  appearance: none;
  box-sizing: border-box;
  display: flex;
  flex:auto 1;
  margin: ${({active}) => active ? '2px' : '0'};
  border-radius: ${({theme}) => theme.radius.control};
  justify-content: center;
  /* height: 36px; */
  opacity: ${({disabled}) => disabled ? '0.5' : ''};
  border: 0;
  padding: ${({isSmall, active}) => isSmall ? '6px 11px' : active ? '8px 23px' : '10px 23px'};
  align-items: center;
  background-color: ${({theme, active}) => active ? theme.isDark ? `${theme.palette[600]}` : `${theme.palette[10]}` : theme.grey[300]};
  box-shadow: ${({active, theme}) => active ? theme.shadows.control : ''};
  color:${({active, theme}) => active ? `${theme.accent[100]}` : `${theme.grey[800]}`};
  white-space: nowrap;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  &:hover{
    cursor: ${({disabled}) => disabled ? 'default' : 'pointer'};
    /* cursor:d */
  }
  &:focus-visible{
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  transition:0.3s all ease-in-out;

  @media screen and (max-width: 768px) {
    flex: none;
    width: 100%;
    min-width: 0;
    min-height: ${({isSmall}) => isSmall ? '32px' : '40px'};
    height: auto;
    padding: ${({isSmall}) => isSmall ? '6px 8px' : '8px 10px'};
    white-space: normal;
    text-align: center;
  }
`

export const RadioLabel = styled.div`
  img {
    width: 16px;
    height: 16px;
    margin-left: 4px;
    object-fit: none;
  }
`
